



export const detailedOperationColumns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    editable: true,
    readOnly: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '20%'
  },
  {
    title: 'From',
    dataIndex: 'location_src_id',
    editable: true,
    readOnly: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  {
    title: 'To',
    dataIndex: 'location_dest_id',
    editable: true,
    readOnly: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  // {
  //   title: 'Source Package',
  //   dataIndex: 'source_package',
  //   editable: true,
  //   className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  //   width: '10%'
  // },
  // {
  //   title: 'Destination Package',
  //   dataIndex: 'destination_package',
  //   editable: true,
  //   className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  //   width: '10%'
  // },
  {
    title: 'Lot/Serial Number',
    dataIndex: 'lot_serial_number_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Demand',
    dataIndex: 'demand_quantity',
    editable: true,
    readOnly: false,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Done',
    dataIndex: 'done_quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  // {
  //   title: 'Reserved',
  //   dataIndex: 'reserved_quantity',
  //   editable: true,
  //   className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  //   width: '10%'
  // },
  {
    title: ''
  }
];


export const operationColumns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '20%'
  },
  {
    title: 'Description',
    dataIndex: 'description',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  {
    title: 'Packaging',
    dataIndex: 'packaging_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '15%'
  },
  {
    title: 'Demand',
    dataIndex: 'demand_quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Done',
    dataIndex: 'done_quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  // {
  //   title: 'Reserved',
  //   dataIndex: 'reserved_quantity',
  //   editable: true,
  //   className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  //   width: '10%'
  // },
  // {
  //   title: 'Deadline',
  //   dataIndex: 'deadline_date',
  //   editable: true,
  //   className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  //   width: '10%'
  // },
  {
    title: ''
  }
]




export const productPurchaseTabColumns = [
  {
    title: 'Vendor',
    dataIndex: 'vendor_id',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '30%'
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '30%'
  },
  {
    title: 'Price',
    dataIndex: 'price',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '30%'
  },
  {
    title: ''
  }
];


export const productPackagingColumns = [
  {
    title: 'Packaging',
    dataIndex: 'packaging',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '44%'
  },
  {
    title: 'Contained Quantity',
    dataIndex: 'conatained_quantity',
    editable: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '44%'
  },
  {
    title: ''
  }
]

export const attributeVariantColumns = [
  {
    title: 'Attribute',
    dataIndex: 'attribute_id',
    editable: true,
    width: '33%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Value',
    dataIndex: 'values',
    editable: true,
    width: '33%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Action',
    fixed: 'right'
  }
]